import React, { useState } from 'react';
import {
  Body,
  Card,
  Desc,
  Distance,
  Logo,
  Meta,
  Name,
  StarButton,
  StarIcon,
  Thumb,
  TopShadow,
} from './RestaurantCard.styles';

export interface RestaurantCardProps {
  name: string;
  /** "식당·200m" 형태의 거리/타입 메타 */
  distance: string;
  description: string;
  logo: string;
  logoSize: { width: number; height: number };
}

const STAR_PATH =
  'M6.87244 1.03648C7.32147 -0.345491 9.27658 -0.345492 9.72561 1.03647L10.6564 3.90122C10.8572 4.51925 11.4332 4.93769 12.083 4.93769H15.0952C16.5483 4.93769 17.1524 6.79712 15.9769 7.65122L13.54 9.42173C13.0142 9.80369 12.7942 10.4807 12.9951 11.0988L13.9259 13.9635C14.3749 15.3455 12.7932 16.4947 11.6176 15.6406L9.18071 13.8701C8.65497 13.4881 7.94308 13.4881 7.41735 13.8701L4.98045 15.6406C3.80488 16.4947 2.22316 15.3455 2.67219 13.9635L3.603 11.0988C3.80381 10.4807 3.58382 9.80369 3.05809 9.42173L0.621197 7.65122C-0.554373 6.79712 0.0497899 4.93769 1.50287 4.93769H4.51504C5.16488 4.93769 5.74082 4.51925 5.94163 3.90122L6.87244 1.03648Z';

/** Figma 101:1614 — Star 1, empty #C7C8C8 / active #11C654 */
function StarToggle() {
  const [filled, setFilled] = useState(false);

  return (
    <StarButton
      type="button"
      aria-label={filled ? '즐겨찾기 해제' : '즐겨찾기 추가'}
      aria-pressed={filled}
      onClick={() => setFilled((prev) => !prev)}
    >
      <StarIcon
        $filled={filled}
        viewBox="0 0 16.5981 15.9339"
        width={18}
        height={18}
        aria-hidden="true"
        focusable="false"
      >
        <path d={STAR_PATH} />
      </StarIcon>
    </StarButton>
  );
}

/**
 * 결과 화면 식당 카드 (entity) — Figma 101:1606 Frame 40
 * - 342×74, #F4F4F4, 상단 그라데이션 그림자 + 우측 별 1개
 */
export function RestaurantCard({
  name,
  distance,
  description,
  logo,
  logoSize,
}: RestaurantCardProps) {
  return (
    <Card>
      <TopShadow aria-hidden="true" />

      <Body>
        <Thumb>
          <Logo
            src={logo}
            alt={`${name} 로고`}
            width={logoSize.width}
            height={logoSize.height}
          />
        </Thumb>

        <Meta>
          <Name>{name}</Name>
          <Distance>{distance}</Distance>
          {description ? <Desc>{description}</Desc> : null}
        </Meta>
      </Body>

      <StarToggle />
    </Card>
  );
}
